import { ItemDocumentDto } from '../types/swaggerTypes'
import { SymphonyProductDocumentDto } from '../types/SymphonyDocumentTypes'

export const SAFETY_LETTER_NOT_AVAILABLE_MESSAGE =
  'The safety letter is not available in DAM for this product. Please contact support.'

const safetyLetterNames = ['mhra safety letter', 'mhra saftey letter']

export const isSafetyLetterDocument = (document: ItemDocumentDto): boolean => {
  const dataPlatformDocument = document as SymphonyProductDocumentDto
  const candidateNames = [
    document.documentType,
    dataPlatformDocument.documentName
  ]

  return candidateNames.some((candidateName) => {
    const normalizedName = candidateName?.trim().toLowerCase()

    return Boolean(
      normalizedName &&
        safetyLetterNames.some((safetyLetterName) =>
          normalizedName.includes(safetyLetterName)
        )
    )
  })
}

export const getSafetyLetterDocuments = (
  documents: ItemDocumentDto[]
): ItemDocumentDto[] => documents.filter(isSafetyLetterDocument)
